import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const DeleteProjectEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.deleteProjectRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.deleteProject(action.payload.projectId).pipe(
        mergeMap(() => of(project.deleteProjectRequestSuccess(action.payload))),
        catchError((error) => of(project.deleteProjectRequestFailure({ error })))
      )
    })
  )
